import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./compare-and-favourite-bar.module.css";
import { useUserStore } from "@cinch-nx/data-user";
import { AuthModal, storePreAuthFavourite } from "@cinch-labs/shared-auth-modal";
import { useFavouritesStore } from "@cinch-nx/data-favourites";
import { useState } from "react";
import { FavouriteCTA } from "./favourite-cta/favourite-cta";
import { sendPostMessage } from "@cinch-labs/cinchapp-config";
import { CompareCTA } from "./compare-cta";
export const CompareAndFavouriteBar = ({ vehicle  })=>{
    const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
    const { vehicleId , thumbnailUrl , make , model , modelYear  } = vehicle;
    const { status: userStatus  } = useUserStore();
    const { addFavourite , removeFavourite , favourites  } = useFavouritesStore();
    const isFavourited = favourites.find((favourite)=>favourite.vehicleId === vehicleId);
    const handleToggleFavourite = async ()=>{
        const messageToSend = {
            make: make,
            model: model || "",
            modelYear: Number(modelYear),
            vehicleId: vehicleId
        };
        if (isFavourited) {
            await removeFavourite(vehicleId);
            sendPostMessage("favouriteVehicleRemoved", messageToSend);
            return;
        }
        await addFavourite(vehicleId);
        sendPostMessage("favouriteVehicleAdded", messageToSend);
    };
    const handleOnFavouriteClick = async ()=>{
        const pathnameWithSearchParams = `${window.location.pathname}${window.location.search}`;
        storePreAuthFavourite({
            id: vehicleId ?? "",
            url: pathnameWithSearchParams
        });
        if (userStatus === "valid") {
            await handleToggleFavourite();
        } else {
            setIsAuthModalOpen(true);
        }
    };
    const handleAuthModalClose = ()=>{
        setIsAuthModalOpen(false);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.container,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.ctaWrapper,
                children: /*#__PURE__*/ _jsx(CompareCTA, {
                    vehicle: vehicle
                })
            }),
            /*#__PURE__*/ _jsx(FavouriteCTA, {
                isSaved: favourites.some((v)=>v.vehicleId === vehicleId),
                onClick: handleOnFavouriteClick
            }),
            /*#__PURE__*/ _jsx(AuthModal, {
                isOpen: isAuthModalOpen,
                handleClose: handleAuthModalClose,
                useBrowserNavigation: true,
                vehicleImage: thumbnailUrl
            })
        ]
    });
};
